module.exports = __webpack_public_path__ + "static/media/alert-black.b9256b9b.svg";